import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-eye",
  "use": "icon-eye-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"icon-eye\"><defs><style>#icon-eye .cls-1{fill:#3a84fb;}</style></defs><path class=\"cls-1\" d=\"M100,54.31C54.31,54.31,36,100,36,100s18.28,45.69,64,45.69S164,100,164,100s-18.28-45.69-64-45.69Zm0,73.1A27.41,27.41,0,1,1,127.41,100,27.41,27.41,0,0,1,100,127.41ZM113.71,100A13.71,13.71,0,1,1,100,86.29,13.71,13.71,0,0,1,113.71,100Zm0,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol